import { GeofenceService } from "@services/geofence.service";
import { GoogleService } from "@services/google.service";
import { VeriDate } from "@services/veriDate.service";
import { IPlannedRouteVisit } from "@tms/_models/IPlannedRouteVisit";
import { PlannedRouteVisitService } from "@tms/_services/planned-route-visit.service";
import { SchedulingService } from "@tms/_services/scheduling.service";
import * as angular from "angular";
import "./scheduleVisitValidation.component.scss";

interface IComponentBindings {
    visit?: IPlannedRouteVisit;
    calculating?: boolean;
}

export class ScheduleVisitValidationComponentController implements angular.IComponentController, IComponentBindings {

    visit: IPlannedRouteVisit;
    calculating: boolean;

    static $inject = [];

    constructor() {}

    $onInit() {

    }

    $onChanges(changes: angular.IOnChangesObject) {
        const visitChange = changes["visit"];

        if (visitChange) {

        }
    }
}

export class ScheduleVisitValidationComponent implements angular.IComponentOptions {
    bindings: any;
    controller: any;
    template: string;

    constructor() {
        this.bindings = {
            visit: "<?",
            calculating: "<?"
        };

        this.controller = ScheduleVisitValidationComponentController;
        this.template = require("./scheduleVisitValidation.component.html");
    }
}
